import React, { useEffect, useState } from "react";
import { AssessmentCard } from "@/components/AssessmentCard";
import { useAssessments } from "@/hooks/useAssessments";
import { CATEGORY_ORDER } from "@/lib/constants";
import api from "@/lib/api";

export default function AssessmentsHub() {
  const { assessments } = useAssessments();
  const [completed, setCompleted] = useState(new Set());

  useEffect(() => {
    api.get("/profile").then(({ data }) => setCompleted(new Set((data.primaries || []).map((p) => p.slug)))).catch(() => {});
  }, []);

  const byCat = {};
  assessments.forEach((a) => { (byCat[a.category] = byCat[a.category] || []).push(a); });
  const cats = CATEGORY_ORDER.filter((c) => byCat[c]);

  return (
    <div>
      <p className="text-xs font-bold uppercase tracking-[0.2em] text-teal-500">Assessments</p>
      <h1 className="mt-2 font-heading text-3xl font-light tracking-tight text-slate-50">All {assessments.length || 18} assessments</h1>
      <p className="mt-2 text-sm text-slate-400">{completed.size} of {assessments.length} completed. Every one you take sharpens your profile and your AI coach.</p>

      {cats.map((cat) => (
        <div key={cat} className="mt-8">
          <h3 className="mb-4 flex items-center gap-2 font-heading text-lg font-medium text-slate-200"><span className="h-1.5 w-1.5 rounded-full bg-teal-400" /> {cat}</h3>
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {byCat[cat].map((a) => (
              <AssessmentCard key={a.slug} a={a} status={completed.has(a.slug) ? "completed" : undefined} to={completed.has(a.slug) ? `/assessment/${a.slug}` : `/a/${a.slug}`} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}
